module.exports = __webpack_public_path__ + "img/vertical_7_2_9005.62965ff2.png";